var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertSuccessExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41425 6.50001L11.7072 2.20701C12.0982 1.81601 12.0982 1.18401 11.7072 0.793006C11.3162 0.402006 10.6842 0.402006 10.2933 0.793006L6.00025 5.08601L1.70725 0.793006C1.31625 0.402006 0.68425 0.402006 0.29325 0.793006C-0.09775 1.18401 -0.09775 1.81601 0.29325 2.20701L4.58625 6.50001L0.29325 10.793C-0.09775 11.184 -0.09775 11.816 0.29325 12.207C0.48825 12.402 0.74425 12.5 1.00025 12.5C1.25625 12.5 1.51225 12.402 1.70725 12.207L6.00025 7.91401L10.2933 12.207C10.4882 12.402 10.7443 12.5 11.0002 12.5C11.2562 12.5 11.5122 12.402 11.7072 12.207C12.0982 11.816 12.0982 11.184 11.7072 10.793L7.41425 6.50001Z",
    fill: "#7256CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSuccessExit);
export default __webpack_public_path__ + "static/media/AlertSuccessExit.49bc75ef7b76ef87a2183350f6717f37.svg";
export { ForwardRef as ReactComponent };